import React, { useCallback, FocusEvent, useState, useEffect, useRef } from "react";
import {
  retornoAutoComplete,
  AutocompleteSaurus,
} from "../autocomplete-saurus/autocomplete-saurus";
import { isEmpty } from "lodash";
import { useGetPessoaClassificacao } from "data/api/gestao/pessoa-classificacao/get-pessoa-classificacao";
import { useGetPessoaClassificacaoById } from "data/api/gestao/pessoa-classificacao/get-pessoa-classificacao-by-id";
import { ClassificacaoModel } from "model/api/gestao/classificacao/classificacao-model";

export interface AutocompleteClassificacoesProps {
  label?: string;
  loadingExterno?: boolean;
  name?: string;
  value?: string;
  defaultValue?: string;
  defaultName?: string;
  error?: boolean;
  helperText?: string | undefined;
  placeholder?: string;
  allowSubmit?: boolean;
  disabled?: boolean;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => any;
  onChange?: (value: retornoAutoComplete) => any;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  fetchOnLoad?: boolean;
  query?: string;
  focus?: boolean;
  onClick?: (e?: any) => any;
}

export const AutocompleteClassificacoes = ({
  onChange,
  loadingExterno,
  fullWidth,
  ...props
}: AutocompleteClassificacoesProps) => {
  const [classificacoesState, setClassificacoesState] = useState<Array<ClassificacaoModel>>(
    new Array<ClassificacaoModel>()
  );
  const {getPessoaClassificacao, carregando: carregandoClassificacoes} = useGetPessoaClassificacao();
  const {getPessoaClassificacaoId, carregando: carregandoClassificacaoById} = useGetPessoaClassificacaoById();

  const [nomeValor, setNomeValor] = useState<string>('')

  const allowFetch = useRef<boolean>(true)

  const getClassificacaoById = useCallback(async (id: string) => {
    try {
      const res = await getPessoaClassificacaoId(id)

      if (res.erro) throw res.erro

      if (!res.resultado) return
      allowFetch.current = false
      setClassificacoesState([res.resultado.data])
    } catch (e: any) {

    }
  }, [getPessoaClassificacaoId])

  const getClassificacoesWrapper = useCallback(async (termo: string) => {
    try {

      const ret = await getPessoaClassificacao(1, `&pageSize=100&${termo.length > 0 ? `query=${termo}` : ''}`);
      if (ret.erro) throw ret.erro;
      let classificacoes: Array<ClassificacaoModel> = new Array<ClassificacaoModel>();
      if (!ret.resultado) return
      if (ret.resultado?.data?.list?.length > 0) {
        classificacoes = ret.resultado?.data?.list as Array<ClassificacaoModel>;
      }
      setClassificacoesState(classificacoes)
    } catch (e: any) { }
  }, [getPessoaClassificacao]);

  const onChangeWrapper = useCallback(
    (value: retornoAutoComplete) => {
      if (onChange) onChange(value);
    },
    [onChange]
  );

  const carregando = carregandoClassificacoes || carregandoClassificacaoById || loadingExterno

  const onPesquisa = useCallback(
    async (termo: string) => {
      await getClassificacoesWrapper(termo);
    },
    [getClassificacoesWrapper]
  );

  useEffect(() => {
    if(!isEmpty(props.defaultValue) && !isEmpty(props.defaultName)){
      setClassificacoesState([new ClassificacaoModel(props.defaultValue, props.defaultName)])
      setNomeValor(props.defaultName!)
      return
    }
    if (!isEmpty(props.defaultValue) && props.fetchOnLoad) {
      getClassificacaoById(props.defaultValue!)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.defaultValue])


  useEffect(() => {
    if (props.value) {
      const valor = classificacoesState.find(item =>
        item.id === props.value
      )
      setNomeValor(valor?.abreviacao ?? '')
      return
    }
    setNomeValor('')
  }, [props, props.fetchOnLoad, props.value, classificacoesState])

  useEffect(() => {
    getClassificacoesWrapper('');
  }, [getClassificacoesWrapper])


  return (
    <AutocompleteSaurus
      disabled={props.disabled}
      name={props.name}
      loading={carregando}
      onChange={onChangeWrapper}
      onPesquisa={onPesquisa}
      onClick={props.onClick}
      opcoes={classificacoesState.sort((a, b) => a.categoria < b.categoria ? -1 : a.categoria > b.categoria ? 1 : 0)}
      optionLabelKey="abreviacao"
      optionValueKey="abreviacao"
      secondaryLabelKey="descricao"
      onBlur={props.onBlur}
      noOptionsText="Não há classificações disponíveis"
      value={nomeValor}
      allowSubmit={props.allowSubmit}
      label={props.label}
      helperText={props.helperText}
      error={props.error}
      placeholder={props.placeholder}
      fullWidth={fullWidth}
      size={props.size}
      focus={props.focus}
    />
  );
};